import axios from "axios";

// Leads (docs/customer-module/leads/00-Overview.md): capture, the list,
// edit, drop, delete and convert into a member application. /leads is a
// customer journey route: errors land under `data`
// (see CustomerJourney/shared/journeyErrors.js), and the list answer is the
// whole envelope, with a sibling `pagination` object.
//
// Every action resolves to the whole envelope (res.data) and rejects with
// what the global interceptor rejects with: the axios response.

export default {
    namespaced: true,

    state: {
        leads: {},
        lead: {},
    },

    getters: {
        leads(state) {
            return state.leads;
        },
        lead(state) {
            return state.lead;
        },
    },

    mutations: {
        SET_LEADS(state, leads) {
            return (state.leads = leads);
        },
        SET_LEAD(state, lead) {
            return (state.lead = lead);
        },
    },

    actions: {
        // GET /leads: status (default open), lead_type, team_id, branch_id,
        // customer_category_id, q, page, per_page
        async fetchLeads({ commit }, params) {
            return await axios
                .get("/api/v1/leads", { params: params })
                .then((res) => {
                    commit("SET_LEADS", res.data);
                    return res.data;
                })
                .catch((err) => Promise.reject(err));
        },

        async fetchLead({ commit }, id) {
            return await axios
                .get(`/api/v1/leads/${id}`)
                .then((res) => {
                    commit("SET_LEAD", res.data);
                    return res.data;
                })
                .catch((err) => Promise.reject(err));
        },

        // {first_name, last_name?, phone, phone_country, team_id?, branch_id?,
        //  customer_category_id, customer_subcategory_id?, lead_type, notes?}
        async createLead({ commit }, payload) {
            return await axios
                .post("/api/v1/leads", payload)
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },

        // {id, ...fields}: any capture field, while the lead is open
        async updateLead({ commit }, { id, ...body }) {
            return await axios
                .patch(`/api/v1/leads/${id}`, body)
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },

        async dropLead({ commit }, id) {
            return await axios
                .post(`/api/v1/leads/${id}/drop`)
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },

        async deleteLead({ commit }, id) {
            return await axios
                .delete(`/api/v1/leads/${id}`)
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },

        // {id, id_type, id_no}: converts the lead and creates the member
        // application (201, data = the application)
        async convertLead({ commit }, { id, ...body }) {
            return await axios
                .post(`/api/v1/leads/${id}/convert`, body)
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },
    },
};
